<template>
  <div class="sys-header">
    <el-header class="el-header-nav radius">
      <el-menu
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        :backgroundColor="'#FFFFFF'"
        text-color="#B3B3B3"
        active-text-color="#1890ff"
      >
        <el-menu-item index="1" style="padding: 0 7px 0 10px">
          <li @click="isHeader()" :title="collapse ? $t('header.open') : $t('header.close')">
            <a href="javascript:;">
              <i :class="collapse ? 'el-icon-lock' : 'el-icon-unlock'" style="margin-bottom: 7px"></i>
            </a>
          </li>
        </el-menu-item>

        <el-submenu index="3" style="float: right">
          <template slot="title">
            <el-avatar
              class="hd-img"
              :src="userAvatar"
              style="width: 30px; height: 30px; margin-right: 5px"
            ></el-avatar>
            {{ nickName }}
          </template>
          <el-menu-item index="3-2" @click="handlePassword">{{ $t("header.password") }}</el-menu-item>
          <el-menu-item index="3-3" @click="handleLoginOut">{{ $t("header.loginOut") }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="4" style="float: right; padding: 0 7px 0 10px">
          <li>
            <el-popover placement="bottom" width="260" popper-class="msg-popover" trigger="hover">
              <div class="msg-content">
                <div class="msg renew" v-if="machineInfo.length > 0">
                  {{ machineInfo }}
                </div>
              </div>
              <a href="javascript:;" :title="$t('common.msg')" slot="reference"
                ><el-badge :is-dot="isDot" class="item"><i class="el-icon-bell"></i></el-badge
              ></a>
            </el-popover>
          </li>
        </el-menu-item>
        <el-menu-item index="5" style="float: right; padding: 0 7px 0 10px">
          <li @click="screen()" :title="$t('header.screen')">
            <a href="javascript:;"><i class="el-icon-c-scale-to-original" style="margin-bottom: 4px"></i></a>
          </li>
        </el-menu-item>
      </el-menu>
    </el-header>
  </div>
</template>

<script>
  import screenfull from "screenfull";
  import config from "@/http/config";

  export default {
    name: "sys-header",
    data() {
      return {
        dialogPassword: false,
        drawer: false,
        config: config,
        confirmInstance: null
      };
    },
    mounted() {
      let avatar = this.$cookies.get("avatar");
      let nickName = this.$cookies.get("nickName");
      this.$store.dispatch("updateAvatar", avatar);
      this.$store.dispatch("updateUser", { nickName: nickName });
      this.getMachineInfo();
    },
    beforeDestroy() {
      if (this.confirmInstance) {
        this.confirmInstance.close();
        this.confirmInstance = null;
      }
    },
    methods: {
      getMachineInfo() {
        this.$api.request(this.$url.Index.machineInfo, this.$method.get).then(res => {
          if (res.code === 0) {
            if (res.data.expiredCount > 0 || res.data.aboutCount > 0) {
              let text = this.getText(res.data.expiredCount, res.data.aboutCount);
              this.$store.dispatch("machineInfo", res.data).then(() => {
                this.confirmInstance = this.$confirm(text, this.$t("common.tip"), {
                  confirmButtonText: this.$t("common.definite"),
                  cancelButtonText: this.$t("common.cancel"),
                  type: "warning"
                });
                this.confirmInstance
                  .then(() => {
                    this.confirmInstance = null;
                    this.$router.push({
                      path: "/machine/user/machine-user",
                      query: {
                        renewalStatus: -1
                      }
                    });
                  })
                  .catch(() => {
                    this.confirmInstance = null;
                  });
              });
            }
          }
        });
      },
      isHeader() {
        if (document.body.clientWidth > 1200) {
          this.$store.dispatch("collapse", !this.$store.state.collapse);
        } else {
          this.$message.warning(this.$t("header.width"));
        }
      },
      passwordDialog(password) {
        this.dialogPassword = password;
      },
      password(password) {
        this.dialogPassword = password;
      },

      handlePassword() {
        this.$emit("password", true);
      },
      handleLoginOut() {
        this.$confirm(this.$t("header.isLoginOut"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$store.dispatch("loginOut");
            this.$router.push("/login");
          })
          .catch(() => {});
      },
      commandUser(command) {
        switch (command) {
          case "personal":
            this.$router.push("/user/info");
            break;
          case "password":
            this.$emit("password", true);
            break;
          case "loginOut":
            this.$confirm(this.$t("header.isLoginOut"), this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            })
              .then(() => {
                this.$store.dispatch("loginOut");
                this.$router.push("/login");
              })
              .catch(() => {});
            break;
        }
      },
      notice() {
        this.$message.warning(this.$t("common.await"));
        //this.$router.push('/user/message')
      },
      isDrawer() {
        this.$message.warning(this.$t("common.await"));
      },
      screen() {
        if (screenfull.isEnabled) {
          let that = this;
          screenfull.toggle().then(() => {
            that.$store.commit("INNER_HEIGHT", document.documentElement.clientHeight);
          });
        } else {
          this.$message.warning(this.$t("header.notScreenfull"));
        }
      },
      isTags() {
        this.$store.dispatch("tagsTop", !this.$store.state.tagsTop);
      },

      getText(expiredCount, aboutCount) {
        let text = "";
        if (expiredCount > 0) {
          text += this.$t("header.yOut").replace("N", expiredCount);
        }
        if (aboutCount > 0) {
          text += text ? "，" : "";
          text += this.$t("header.nOut").replace("N", aboutCount);
        }
        if (expiredCount > 0 || aboutCount > 0) {
          text += this.$t("header.renew");
        }
        return text;
      }
    },
    computed: {
      collapse() {
        return this.$store.state.collapse;
      },
      userAvatar() {
        return this.$store.state.avatar;
      },
      nickName() {
        return this.$store.state.nickName;
      },
      isDot() {
        return this.$store.state.isDot;
      },
      machineInfo() {
        let info = this.$store.state.machineInfo;
        return this.getText(info.about, info.expired);
      }
    }
  };
</script>

<style lang="scss">
  .el-badge__content.is-fixed.is-dot {
    top: 20px;
  }

  .msg-popover {
    .msg-content {
      height: 280px;
      .msg {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 4px;
        padding: 10px;
        cursor: pointer;
        margin-bottom: 5px;
      }
      .msg:last-child {
        margin-bottom: 0;
      }
      .no-more {
        text-align: center;
      }
    }
  }
  .el-header {
    width: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 60px !important;
    line-height: 60px;
    background-color: #fff;
    box-sizing: border-box;
    -webkit-transition: left 0.28s;
    transition: left 0.28s;

    .el-badge {
      display: block;
    }

    .el-header-nav {
      height: 50px;
      position: relative;
    }

    .drop {
      font-size: 16px;
    }

    .el-ul {
      padding: 0 10px;

      li {
        height: 60px;
        float: left;
        line-height: 60px;

        .el-breadcrumb {
          line-height: 60px;
        }

        a {
          display: block;
          color: rgb(86, 86, 86);
          padding: 0 15px;
          font-size: 25px;

          .el-dropdown-link {
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
          }

          .hd-img {
            margin-left: 10px;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
          }
        }

        a:hover {
          color: #409eff;

          .hd-name {
            color: #409eff;
          }
        }

        .el-badge__content {
          margin-top: 12px;
        }
      }
    }

    .el-ul-left {
      position: absolute;
      top: 0;
      left: 0;
    }

    .el-ul-right {
      position: absolute;
      right: 0;
      top: 0;
    }

    .el-dropdown {
      display: block;
      font-size: 25px;
    }

    .icon-gengduo {
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* Internet Explorer */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg);
    }
  }
</style>
